module.exports = __webpack_public_path__ + "img/banner.95fd7df9.jpg";